<app-header [showHamburger]="false"></app-header>
<div class="grid place-content-center mt-10">
  @if (isAuthenticated()) {
    <div class="text-2xl antialiased font-sans">Logging out</div>
  } @else {
    <div class="text-2xl antialiased font-sans">You have been logged out. Thank you for using Panoptyc!</div>
  }
</div>
